import { Contact } from "screens/mass-mail/types";
import { CandidateInfo } from "../types";

/**
 * Converts a CandidateInfo into a MassMail Contact.
 */
export function convertCandidateToContact(candidate: CandidateInfo): Contact {
  const firstName = candidate.personalDetails?.firstName || "";
  const lastName = candidate.personalDetails?.lastName || "";
  const name = `${firstName} ${lastName}`.trim() || "Onbekend";

  return {
    id: String(candidate.id),
    name,
    firstName,
    lastName,
    email: candidate.personalDetails?.email || "",
    resourceId: String(candidate.id),
    phoneMobile: candidate.personalDetails?.phoneNumber || "",
    units: [],
    buildingId: candidate.buildingId || "",
    buildingName: candidate.buildingId || "",
    unitId: candidate.unitId || "",
    unitNumber: candidate.unitId || "",
  };
}

/**
 * Converts multiple candidates into MassMail Contacts.
 */
export function convertCandidatesToContacts(candidates: CandidateInfo[]): Contact[] {
  return candidates
    .map(convertCandidateToContact)
    .filter((c) => !!c.email);
}
